import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Format initial values when the controller connects
    this.inputTargets.forEach((input) => {
      if (input.value) {
        input.value = this.formatValue(input.value)
      }
    })
  }

  format(event) {
    event.target.value = this.formatValue(event.target.value)
  }

  formatValue(value) {
    // Parse as number first so "150000.0" from DB becomes 150000, not 1500000
    const str = String(value || "").replace(/,/g, "")
    const num = parseFloat(str)
    if (Number.isNaN(num) || num <= 0) return ""
    const whole = Math.floor(num)
    return whole.toLocaleString()
  }

  // Clean formatting before form submission so server receives plain integer
  beforeSubmit() {
    this.inputTargets.forEach((el) => {
      // Remove commas before submission
      el.value = String(el.value || "").replace(/,/g, "")
    })
  }
}